'use client'
import { useTranslations } from 'next-intl'

import { Link } from '@/i18n/navigation'
import { Display, Paragraph } from '@/components/atoms/Typography'
import Flex from '@/components/atoms/Flex'
import Button from '@/components/atoms/Button'
import Icon from '@/components/atoms/Icon'

import styles from './NotFoundMessage.module.scss'

const NotFoundMessage = () => {
  const t = useTranslations('NotFound')

  return (
    <Flex
      className={styles.container}
      justifyContent='center'
      alignItems='center'
      direction='column'
      gap='2rem'
    >
      <Display
        as='h1'
        className={styles.title}
        size='lg'
        weight='regular'
        family='sans'
      >
        <span>404</span>
        <Paragraph
          as='span'
          align='center'
          dangerouslySetInnerHTML
          content={t.raw('title')}
          size='lg'
          weight='regular'
        />
      </Display>

      <Button
        autoWidth
        variant='primary'
        size='large'
        as={Link}
        href='/'
        Icon={() => <Icon iconName='ArrowRight' />}
      >
        {t('button')}
      </Button>
    </Flex>
  )
}

export default NotFoundMessage
